// extracted by mini-css-extract-plugin
export default {"ReactTransliterate":"styles_ReactTransliterate__ccxgX","Active":"styles_Active__pskkk"};